// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tffrudjjzwcrilxigmnb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRmZnJ1ZGpqendjcmlseGlnbW5iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1NDQxMzYsImV4cCI6MjA4ODEyMDEzNn0.59f80RbsRIqXOY-_OC-pDOezTmMjca4jrQbNIM0-2sM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});